import React from 'react';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Caption } from '../../Common/Caption';
import {
  Selector,
  SelectorItem,
  SelectorImageItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { getBaseProductType } from '../../../helpers/getBaseProductType';

type OnClick = (
  rollDirection: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (rollDirection, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      rollDirection,
    },
  });

export const RollDirection = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);
  const productType = getBaseProductType(state.context);
  const rollDirectionTypes = baseProduct
    ? baseProduct.metafields.roll_direction || []
    : [];
  const {
    custom: { rollDirection },
  } = state.context;

  if (
    isCurrentState('rollDirection', state) &&
    rollDirectionTypes.length === 0
  ) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Roll direction</Heading>
      <Caption>Roll direction</Caption>
      <Selector isSlider={true}>
        {rollDirectionTypes.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'rollDirection',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={option === rollDirection}
              onClick={onClick(option, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
